module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/sp/common/icon_saved-47ae63e789e1bf617d1d1d41835d3048.svg";